import {useEffect, useRef} from 'react';
import capClient from './cap-client';

export default function useCap({formRef, formId, apiEndpoint, onStateChange}) {
    const containerRef = useRef(null);
    const controllerRef = useRef(null);
    const onStateChangeRef = useRef(onStateChange);

    onStateChangeRef.current = onStateChange;

    useEffect(() => {
        const formElement = formRef?.current || (formId ? document.getElementById(formId) : null);

        if (!formElement || !apiEndpoint) {
            return undefined;
        }

        const controller = capClient.createCapController({
            formElement,
            apiEndpoint,
            onStateChange: (nextState) => onStateChangeRef.current?.(nextState),
        });

        controllerRef.current = controller;
        controller.init();

        return () => {
            controller.destroy();
            if (controllerRef.current === controller) {
                controllerRef.current = null;
            }
        };
    }, [formRef, formId, apiEndpoint]);

    return {
        containerRef,
        controllerRef,
    };
}
